import { Color } from "@repo/app-types/constants/colors";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { Size } from "@repo/ui/helpers/helpers";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { Pill } from "@repo/ui/Pills/pill";
import type { FC } from "react";
import type { PlaybookYesNoCriterionEqualsCondition } from "./playbookCondition.js";

export interface PlaybookYesNoCriterionConditionMenuProps {
  playbookId: PlaybookId;
  criterionId: string;
  onSelect: (condition: PlaybookYesNoCriterionEqualsCondition) => void;
}

export const PlaybookYesNoCriterionConditionMenu: FC<
  PlaybookYesNoCriterionConditionMenuProps
> = (props) => {
  return (
    <SimpleMenu aria-label="Yes/No criterion value">
      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            playbookId: props.playbookId,
            criterionId: props.criterionId,
            gradingValueType: "yes_no",
            operator: "=",
            value: true,
          })
        }
      >
        <span className="flex items-center gap-2">
          is{" "}
          <Pill
            size={Size.SMALL}
            color={Color.Green}
            label={<span className="w-[2.5ch] text-center">Yes</span>}
          />
        </span>
      </SimpleMenuItem>

      <SimpleMenuItem
        onAction={() =>
          props.onSelect({
            playbookId: props.playbookId,
            criterionId: props.criterionId,
            gradingValueType: "yes_no",
            operator: "=",
            value: false,
          })
        }
      >
        <span className="flex items-center gap-2">
          is{" "}
          <Pill
            size={Size.SMALL}
            color={Color.Red}
            label={<span className="w-[2.5ch] text-center">No</span>}
          />
        </span>
      </SimpleMenuItem>
    </SimpleMenu>
  );
};
